import React, { FC, ReactNode } from "react"
import { Box, Stack, useMediaQuery, useTheme } from "@carrotfertility/carotene-core"

type TwoColumnRightPrimaryProps = {
  secondaryContent: ReactNode
  primaryContent: ReactNode
  bottomContent?: ReactNode
}

const TwoColumnRightPrimary: FC<TwoColumnRightPrimaryProps> = ({
  secondaryContent,
  primaryContent,
  bottomContent = null
}) => {
  const theme = useTheme()
  const showDesktopContent = useMediaQuery(theme.breakpoints.up("lg"))

  const desktopContent = (
    <Box
      sx={(theme) => ({
        display: "grid",
        gridTemplateColumns: "1fr 2fr",
        gap: theme.tokens.spacing.xxxl,
        maxInlineSize: "60rem",
        minInlineSize: "40rem"
      })}
    >
      <Box sx={{ minInlineSize: "14.5rem", maxInlineSize: "20rem" }}>{secondaryContent}</Box>
      <Box sx={{ minInlineSize: "24rem", maxInlineSize: "37.5rem" }}>{primaryContent}</Box>
    </Box>
  )

  const mobileContent = (
    <Box sx={{ inlineSize: "100%" }}>
      <Stack
        sx={(theme) => ({
          gap: theme.tokens.spacing.xl
        })}
      >
        {secondaryContent}
        {primaryContent}
      </Stack>
    </Box>
  )

  const responsiveContent = showDesktopContent ? desktopContent : mobileContent

  return (
    <>
      <Box sx={{ display: "flex" }}>{responsiveContent}</Box>
      {bottomContent && <Box sx={(theme) => ({ marginBlockStart: theme.tokens.spacing.xxxl })}>{bottomContent}</Box>}
    </>
  )
}

export default TwoColumnRightPrimary
